// extracted by mini-css-extract-plugin
module.exports = {"cardWrapper":"Vietujq2","favicon":"l1wCZlRd","content":"f9BiSgoH","onlyUrl":"CasJauWC","infoWrapper":"LVD0nDpn","title":"AdqfYV8k","url":"BDs3u1dq","dragHandle":"Ej_U1UVT"};